'use strict';
import React from 'react';
import PropTypes from "prop-types";
import classnames from 'classnames';

const Col = (props) => {
    const content = props.children ? props.children : "\u00a0";
    const className = classnames(props.className, 'o-col-' + props.size);

    return props.style ? <div className={className} style={props.style}>{content}</div> : <div className={className}>{content}</div>;
};

Col.propTypes = {
    size: PropTypes.number,
    className: PropTypes.string,
    children: PropTypes.node,
    style: PropTypes.object
};
Col.defaultProps = { size: 6 };

export default Col;